module.exports = __webpack_public_path__ + "img/overfold-graph.b0478753.png";